import axios from '../../plugins/axios-common'

export default {
    namespaced: true,
    state: {
        information: {},
    },
    actions: {
        fetchInformation ({commit}) {
            return  axios({
                method: 'get',
                url: '/api/wiki',
            }).then((resp) => {
                commit('setInformation', resp.data)
            })
        },
    },
    mutations: {
        setInformation(state, information) {
            state.information = information
        }
    },
    getters: {
        information(state) {
            return state.information
        }
    },
}
